import {FontItem} from '~/common/fabric/CreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';
import {RECOMMENDED_FONTS} from '~/common/fabric/CreateDesign/constants';

export function AllFonts({onClick, selectedFont}) {
  return window.fonts
    .filter((font) => !RECOMMENDED_FONTS.some((rf) => rf.name === font.name))
    .map((option) => (
      <FontItem
        font={option}
        key={option.name}
        onClick={onClick}
        selected={option.name === selectedFont?.name}
      />
    ));
}
